function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function partialDeepMatch(actual: unknown, expected: unknown): boolean {
  if (Array.isArray(expected)) {
    return (
      Array.isArray(actual) &&
      actual.length === expected.length &&
      expected.every((entry, index) =>
        partialDeepMatch(actual[index], entry),
      )
    );
  }

  if (isRecord(expected)) {
    if (!isRecord(actual)) {
      return false;
    }
    return Object.entries(expected).every(([key, value]) =>
      partialDeepMatch(actual[key], value),
    );
  }

  return Object.is(actual, expected);
}

